import styled from "styled-components"

export const HeaderSpanMainDiv = styled.div`
 .block-header {
    width: fit-content;
    height: fit-content;
  }
  .block-header-text-wrapper {
    background: var(--main-bg);
    border-radius: 14px;
    display: flex;
    gap: 10px;
    padding: 6px 12px;
    white-space: pre;
    text-transform: uppercase;
    > p {
      padding: 0;
      font-size: 14px;
      margin: 0;
    }
  }

  .block-header-radial-gradient {
    border-radius: 99px;
    background: linear-gradient(
  163deg,
  rgb(255, 223, 125) 28%,   /* The Base: Warm Gold */
  rgb(161, 115, 69) 54%,    /* The Shadow: Deep Bronze/Brown */
  rgba(21, 21, 21, 1) 68%,         /* The Void: Pure Black */
  rgb(97, 150, 242) 100%    /* The Pop: Cornflower Blue */
);
    display: flex;
    justify-content:center;
    gap: 10px;
    padding: 2.5px;
    align-items: center;
    width: 100%;
  }
`